module.exports = __webpack_public_path__ + "media/images/MRM-jay-d9a375c9.png";